module.exports = __webpack_public_path__ + "img/gamblers-anonymous-colour.926929b4.svg";